/**
 * Copyright 2009-2018, Figure (http://www.commercebyfigure.com)
 *
 * Licensed under The BSD License
 * Redistributions of files must retain the above copyright notice.
 *
 * @copyright    Copyright 2009-2018, Figure (http://www.commercebyfigure.com)
 * @package      Figure - Cart
 * @author       Ian Tucker <ian at commercebyfigure.com>
 * @license      BSD License (http://www.opensource.org/licenses/bsd-license.php)
 */

$(document).ready(function () {
  // Figure
  $("#shipping_insurance").bind("change", toggleInsurance);
  $("a.add-cart-modal").bind("click", addCart);
  //$("#shipping_methods").on('change', 'input:radio.shipping_method', updateShipping);
  $("#credit-card-form").bind("submit", tokenizeCard);
  $(".product-order").bind("click", addCart);
  $(".btn-add-cart").bind("click", addCart);
  $(".btn-add-on-cart").bind("click", addOnCart);
  $(".btn-add-club").on("click", addClub);
  $("input[type=radio][name=requested_ship_date]").on(
    "click",
    updateRequestedShipDate
  );
  $("#requested_ship_date").bind("change", updateRequestedShipDate);
  selectFirstRadioOption("requested_ship_date");
  $("#credit-card-form #state").bind("change", internationalShippingSelect);

  // Purchase Quantity Selector
  $(".qty").on("change", function () {
    var selector = $(this).attr("id");

    var parts = selector.split("qty-");
    var id = parts[1];
    var val = $(this).val();

    updateQuantity(id, val);
    checkWishRequests(id, val);
  });

  // Wish Quantity Selector
  $(".wish-qty").bind("change", function () {
    var parts = $(this).attr("id").split("qty-");
    var id = parts[1];
    var val = $(this).val();

    updateWishQuantity(id, val);
  });

  $("a.launch-modal").bind("click", launchModal);
  $("input:radio.launch-modal").bind("change", launchModalSelect);
  $("select.launch-modal").bind("change", launchModalSelect);

  /**
   * Click Handler for /offering/checkout
   * Appends Spinner to body and disabled button
   * to prevent duplicate order
   *
   * Last Edit: 9/01/2020
   *
   * @author Victor Ragojos
   */
  $("#button-place-order").on("mousedown", function (e) {
    e.stopPropagation();

    $(this).attr("disabled", true);
    const modal = $('<div id="checkoutSpinnerModal"></div>');
    modal.addClass("fade");
    modal.addClass("modal");
    modal.attr("keyboard", false);
    modal.attr("data-backdrop", "static");
    const dialog = $('<div class="modal-dialog modal-dialog-centered"></div>');

    const content = $('<div class="modal-content d-flex"></div>');
    content.addClass("align-items-center");
    const body = $('<div class="modal-body d-flex"></div>');
    const spinner = $('<div class="spinner-border text-primary"></div>');

    body.append(spinner);

    content.append(body);
    dialog.append(content);
    modal.append(dialog);

    content.css({
      border: "none",
      backgroundColor: "transparent",
    });

    spinner.css({
      zIndex: 9999,
    });

    $("body").append(modal);
    modal.modal("show");

    $("#cartForm").submit();
  });

  $("form").bind("submit", function (e) {
    var $form = $(this);

    if ($form.data("submitted") === true) {
      // Previously submitted - don't submit again
      e.preventDefault();
    } else {
      // Mark it so that the next submit can be ignored
      $form.data("submitted", true);
    }
  });
});

// If no radio option is selected, select the first one
function selectFirstRadioOption($name) {
  $radio = $("input[type=radio]." + $name);
  if ($radio.length > 0) {
    if (!$radio.filter(":checked").length) {
      $radio[0].checked = true;
    }
  }
}

// Update Display
function updateDisplay(id, value) {
  var $obj = $("#" + id);

  if (value > 0) {
    value = addCommas(value);
    $obj.html(value);
  } else {
    $obj.html("0");
  }
}

// Launch modal from Link
function launchModal($event) {
  var $href = $(this).attr("href").split("#");
  var $url = $href[0];
  var $id = $href[1];

  $event.preventDefault();

  if ($url.length > 0) {
    $.get($url, function ($data) {
      $("#" + $id).html($data);
      $("#" + $id).modal({ backdrop: "static" });
    });
  } else {
    $("#" + $id).modal({ backdrop: "static" });
  }
}

// Launch modal from Select
function launchModalSelect($event) {
  var $href = $(this).val().split("#");
  var $url = $href[0];
  var $id = $href[1];

  $event.preventDefault();

  if ($url.length == 0) {
    $("#" + $id).modal({ backdrop: "static" });
  } else if ($id == undefined || $id.length == 0) {
    window.location = $url;
  } else {
    $.get($url, function ($data) {
      $("#" + $id).html($data);
      $("#" + $id).modal({ backdrop: "static" });
    });
  }
  //return false;
}

function addCart(event) {

	if (
		$(this).hasClass("add-to-added")
		&& $(this).text().includes('Add')
		&& !$(this).text().includes('Added')
	) {
		$(this).text('Added');
	}

  // Everything after /add/
  var $parts = $(this).attr("href").split("/add/");
  
  // Break up by forward slash (/)
  $parts = $parts[1].split("/");
  
  // First Argument is SKU
  var $sku = $parts[0];

  let $quant = $(this).closest("form").find("select").val() || 1;

  //var modalSize = 'small-modal';
  //$('.site-mask').fadeIn();
  //$('.site-modal').attr('class', 'site-modal '+modalSize);
  //$('body').addClass('modal-open').addClass('modal-on-page');
  //$('.site-modal').removeAttr('aria-hidden').attr('tab-index','1');
  $("#cartModal").modal();
  $("#cartModal .modal-load-area").html("").removeClass("loaded");
  $.getJSON(
    "/cart/add_modal/" + $sku + "/" + $quant + ".json",
    function (data) {
      $("#cartModal .modal-load-area").html(data.html).addClass("loaded");
      if (data.quantity > 0) {
        // NOTE: For analytics since `preventDefault` prevents other `click` event listeners from being triggered
        try {
          fbq("track", "AddToCart", {
            "currency": "USD",
            "value": data.total.subtotal,
            "contents": [{ id: data.product.sku, name: data.product.name, quantity: data.quantity }]
          });

          const formatter = new Intl.NumberFormat('en-US', {
            currency: "USD",
            style: "currency",
          });

          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              "currency": "USD",
              "value": data.total.subtotal,
              "items": [{ 
                item_id: data.product['sku'],
                item_name: data.product['name'],
                item_brand: data.product['producer'],
                item_category: data.product['country'],
                item_category2: data.product['region'],
                item_category3: data.product['producer'],
                item_variant: data.product['blends'],
                price: formatter.format(data.product['price']),
                quantity: data.quantity,
              }],
            },
          });
        } catch(e) {}

        $("#cartcount").html(
          " <span class='badge badge-pill badge-primary'>" +
            data.quantity +
            "</span>"
        );
        $(".cart-link").removeClass("hide-cart");
        $(".face").addClass("happy");

        // Check if klaviyo instance is available
        // in global window object
        if (!!window._learnq) klaviyoAddCart(data);
      } else {
        $("#cartcount").html("");
        $(".face").removeClass("happy");
      }
      $(".face").addClass("show");
    }
  );
  event.preventDefault();
  return false;
}

function addOnCart(event) {

  // Everything after /add/
  var $parts = $(this).attr("href").split("/add/");
  
  // Break up by forward slash (/)
  $parts = $parts[1].split("/");
  
  // First Argument is SKU
  var $sku = $parts[0];

  let $quant = $(this).closest("form").find("select").val() || 1;

  //var modalSize = 'small-modal';
  //$('.site-mask').fadeIn();
  //$('.site-modal').attr('class', 'site-modal '+modalSize);
  //$('body').addClass('modal-open').addClass('modal-on-page');
  //$('.site-modal').removeAttr('aria-hidden').attr('tab-index','1');
  $("#cartModal").modal();
  $("#cartModal .modal-load-area").html("").removeClass("loaded");
  $.getJSON(
    "/purchase/add_modal/" + $sku + "/" + $quant + ".json",
    function (data) {
      $("#cartModal .modal-load-area").html(data.html).addClass("loaded");
      if (data.quantity > 0) {
        $("#cartcount").html(
          " <span class='badge badge-pill badge-primary'>" +
            data.quantity +
            "</span>"
        );
        $(".cart-link").removeClass("hide-cart");
        $(".face").addClass("happy");

        // Check if klaviyo instance is available
        // in global window object
        if (!!window._learnq) klaviyoAddCart(data);
      } else {
        $("#cartcount").html("");
        $(".face").removeClass("happy");
      }
      $(".face").addClass("show");
    }
  );
  event.preventDefault();
  return false;
}

function addClub(e) {
  const data = $(this).data();
  console.log(data);
  klaviyoAddClub(data);
}

// Toggle Insurance
function toggleInsurance() {
  var insurance = $("#shipping_insurance").is(":checked");

  if (!insurance) insurance = 0;

  if (insurance == true) insurance = 1;

  var page = getPage();

  $.getJSON(
    "/" + page + "/update_insurance/" + insurance + "/",
    function (data) {
      updateDisplay("shipping_display_alt", parseFloat(data.shipping).toFixed(2));
      updateDisplay("shipping_display", parseFloat(data.shipping).toFixed(2));
      updateDisplay("tax_display", parseFloat(data.tax).toFixed(2));
      updateDisplay("total_display_alt", parseFloat(data.total).toFixed(2));
	    updateDisplay("tax_display", data.tax.toFixed(2));
      updateDisplay("total_display", parseFloat(data.total).toFixed(2));
      updateDisplay("total_display_top", parseFloat(data.total).toFixed(2));
    }
  );
}

// Updates quantity in cart
function updateQuantity(id, value) {
  //$('#secure-checkout-spinner').show();

  if (value <= 0) {
    value = "0";
  }

  var page = getPage();

  $.getJSON(
    "/" + page + "/update_quantity/" + id + "/" + value + "/",
    function (data) {
      updateDisplay("item_count_display", data.quantity);
      updateDisplay("subtotal_display", data.subtotal.toFixed(2));
      updateDisplay("subtotal_display_2", data.subtotal.toFixed(2));
      updateDisplay("shipping_display", data.shipping.toFixed(2));
	    updateDisplay("crv_display", data.crv.toFixed(2));
      updateDisplay("discount_display", data.discount.toFixed(2));
      updateDisplay("tax_display", data.tax.toFixed(2));
      updateDisplay("total_display_alt", data.total.toFixed(2));
      updateDisplay("total_display", data.total.toFixed(2));

      if ($(".add-your-full-allocation").length) {
        console.log(data.allocation_remaining);
        if (data.allocation_remaining === true) {
          console.log("you have more to add");
          $(".add-your-full-allocation").show();
        } else {
          console.log("you have NO more to add");
          $(".add-your-full-allocation").hide();
        }
      }
      if (data.quantity > 0) {
        $("#cartcount").html(
          " <span class='badge badge-pill badge-primary'>" +
            data.quantity +
            "</span>"
        );
        $("#cartcountnav").html(
          " <span class='badge badge-pill badge-primary'>" +
            data.quantity +
            "</span>"
        );
        $(".cart-link").removeClass("hide-cart");
      } else {
        $("#cartcount").html("");
        $("#cartcountnav").html("");
        $(".cart-link").addClass("hide-cart");
      }
      if (data.expires > 0) {
        var totalSecs = data.expires;
        var secondz = totalSecs * 1000;
        console.log(totalSecs);
        if (secondz > 0) {
          window.setTimeout(function () {
            location.href = "/offering/expired/";
          }, secondz);
        }
      }
      if ($("#shipping-offer-min").length) {
        var $min = $("#shipping-offer-min").val();
        swapAddBottleText(parseInt($min), parseInt($quantity));
      }
      if (data.quantity < 6) {
        $(".cart-shipping-message").removeClass("blank");
        $(".more-bottles").removeClass("no-more");
        $("#moar").html(6 - data.quantity);
        $(".qualified").removeClass("success");
        if (data.quantity == 5) {
          $("#plural").hide();
        } else {
          $("#plural").show();
        }
      } else {
        $(".cart-shipping-message").removeClass("blank");
        $(".more-bottles").addClass("no-more");
        $(".qualified").addClass("success");
      }
      //$('#secure-checkout-spinner').hide('400');
      $("#secure-checkout-update-cart").hide();
    }
  ).done(function () {
    var isDiscounted = $("#enable_product_volume_discounts").val();
    if (isDiscounted === "TRUE") {
      updateDiscoutPrice();
    }
  });
}
function updateDiscoutPrice() {
  $.getJSON("/cart/get_items", function (data) {
    $.each(data, function (i, item) {
      var theID = "#Price_" + item.sku;
      var theVolID = "#Vol_" + item.sku;
      $(theID).html(item.price);
      if (item.has_volume_discount == 1) {
        $(theVolID).fadeIn();
      } else {
        $(theVolID).fadeOut();
      }
    });
  });
}

// Updates quantity in wishlist
function updateWishQuantity(id, value) {
  if (value < 0) {
    value = 0;
  }
  $.getJSON(
    "/offering/update_wishlist/" + id + "/" + value + "/",
    function (data) {}
  );
}

function checkWishRequests(id, quant) {
  var max = $("#qty-" + id + " option:last-child").val();

  if (quant == max) {
    $(".wishwrapper-" + id).show();
  }
  if (parseInt(quant) < parseInt(max)) {
    $(".wishwrapper-" + id).hide();
    $("#wishqty-" + id).val($("#wishqty-" + id + " option:first").val());
    updateWishQuantity(id, 0);
  }
}

function internationalShippingSelect() {
  var state = $(this).val();

  if (state == "Int") {
    $("#state_select_field").html(
      "<input type='text' size='10' name='data[state]' value='' placeholder='International...'/>"
    );
  }
}

function updateRequestedShipDate() {
  var ship_date = $(this).val();

  var page = getPage();

  $.getJSON(
    "/" + page + "/select-requested-ship-date/" + ship_date + "/",
    function (data) {}
  );
}

// Update Shipping Method
function updateShipping() {
  var fields = [
    "first_name",
    "last_name",
    "company",
    "address",
    "address_2",
    "city",
    "state",
    "zip",
    "phone",
  ];
  var ship_method = $("input:radio.shipping_method:checked");

  var page = getPage();

  // Not Pickup
  if (!ship_method.hasClass("pickup")) {
    $.each(fields, function (key, value) {
      $("#" + value).val("");
      $("#" + value).removeAttr("disabled");
    });

    $("#address-form-container").removeClass("hidden");
    $("#shipping-method-description").addClass("hidden");
    $("#shipping-address-form").attr("action", "/cart/add-address.html");

    $.getJSON(
      "/" + page + "/update_shipping_method/" + ship_method.val() + ".json",
      function (data) {}
    );
    return;
  }

  // Pickup Address
  $.getJSON(
    "/" + page + "/update_shipping_method/" + ship_method.val() + ".json",
    function (data) {
      data = data.shipment.address;
      $.each(fields, function (key, value) {
        $("#" + value).attr("disabled", "disabled");
        $("#" + value).val(data[value]);
      });

      var description = $(
        "#shipping-method-message-" + ship_method.val()
      ).html();
      if (description) {
        $("#shipping-method-description").html(description);
        $("#shipping-method-description").removeClass("hidden");
      } else {
        $("#shipping-method-description").addClass("hidden");
      }

      $("#address-form-container").addClass("hidden");
      $("#shipping-address-form").attr("action", "/cart/checkout.html");
    }
  );
}

function getPage() {
  var $parts = window.location.pathname;
  $parts = $parts.split("/");
  return $parts[1];
}

// Add a Thousdands Seperator to a numeric string
function addCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function klaviyoAddCart(payload) {
  const { url, cart, total, product, quantity } = payload;
  if (
    !Array.isArray(cart) ||
    typeof url !== "string" ||
    typeof total !== "object" ||
    typeof product !== "object"
  ) {
    return;
  }

  const { credits, discount, shipping, subtotal, tax } = total;

  const cats = [];
  if (typeof product.categories === "object") {
    Object.keys(product.categories).forEach((k) => {
      const c = product.categories[k];
      cats.push(c.name);
    });
  }

  const prodURL = `${url}/product/detail/${product.sku}/`;
  const coURL = `${url}/cart/`;
  window._learnq.push([
    "track",
    "Added to Cart",
    {
      $value: subtotal,
      AddedItemProductName: formatProductName(product),
      AddedItemProductID: product.id,
      AddedItemSKU: product.sku,
      AddedItemCategories: cats,
      AddedItemImageURL: product.image,
      AddedItemURL: prodURL,
      AddedItemPrice: product.price,
      AddedItemQuantity: quantity,
      ItemNames: cart.map((p) => formatProductName(p)),
      CheckoutURL: coURL,
      Items: cart.map((p) => ({
        ProductID: p.id,
        SKU: p.sku,
        ProductName: formatProductName(p),
        Quantity: quantity,
        ItemPrice: p.price,
        RowTotal: p.price * quantity,
        ProductURL: prodURL,
        ImageURL: p.image || "",
        ProductCategories:
          (typeof p.categories === "object" &&
            Object.keys(p.categories).map((k) => {
              return p.categories[k].name;
            })
          ) || [],
      })),
    },
  ]);
}

function klaviyoAddClub(data) {
  const { id = "", sku = "", url = "", name = "", image = "" } = data;
  window._learnq.push([
    "track",
    "Added to Cart (Club)",
    {
      $value: 1.0,
      AddedItemProductName: name,
      AddedItemProductID: id,
      AddedItemSKU: id,
      AddedItemCategories: ["Club"],
      AddedItemImageURL: url,
      AddedItemURL: url,
      AddedItemPrice: 1.0,
      AddedItemQuantity: 1,
      ItemNames: [name],
      CheckoutURL: url,
      Items: [
        {
          ProductID: id,
          SKU: id,
          ProductName: name,
          Quantity: 1,
          ItemPrice: 1.0,
          RowTotal: 1.0,
          ProductURL: `${url}${sku}`,
          ImageURL: image,
          ProductCategories: ["Club"],
        },
      ],
    },
  ]);
}

function formatProductName(product) {
  return `${product.name} ${product.subtitle}`;
}
